export default "__VITE_ASSET__DtTFtiT8__"